/**
 * Initializes the minus and plus buttons for problem quantity adjustment.
 */
export function setupProblemQuantityCounter() {
	const minusBtn = document.getElementById("minus");
	const plusBtn = document.getElementById("plus");
	const countInput = document.getElementById("problemQuantityCount");

	if (!countInput) {
		return;
	}

	let countValue = parseInt(countInput.value, 10);

	minusBtn.addEventListener("click", () => adjustProblemQuantity(-5));
	plusBtn.addEventListener("click", () => adjustProblemQuantity(5));

	/**
	 * Adjusts the problem quantity by the given step value.
	 * The quantity is bounded between 5 (minimum) and 20 (maximum) problems.
	 * @param {number} change - Amount to add (positive) or subtract (negative).
	 */
	function adjustProblemQuantity(change) {
		// Only allow decrement if above minimum (5) and increment if below maximum (20)
		if ((countValue > 5 && change < 0) || (countValue < 20 && change > 0)) {
			countValue += change;
			countInput.value = countValue;
		}
	}
}
